<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">rule</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">{{ data.titulo }}</h2>
        <span class="modal-subtitle">Pesquise por nome, observação, CST ou classificação tributária.</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" (click)="cancelar()" aria-label="Fechar">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    <form class="search-area" (ngSubmit)="pesquisar()">
        <mat-form-field appearance="outline">
            <mat-label>Pesquisar regra</mat-label>
            <input matInput [formControl]="pesquisaControl" placeholder="Nome, CST, cClassTrib ou #ID">
            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                <mat-icon class="material-symbols-outlined">search</mat-icon>
            </button>
        </mat-form-field>
    </form>

    @if (regras.length === 0 && !isLoading) {
        <app-empty-state
            icon="search_off"
            title="Nenhuma regra tributária encontrada"
            subtitle="Ajuste a pesquisa ou os termos informados para encontrar a regra desejada.">
        </app-empty-state>
    }

    @if (isLoading && regras.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
    }

    <div class="regras-list">
        @for (regra of regras; track regra.idRegraTributaria) {
            <div class="card-mobile regra-card" [class.selected-card]="isSelecionada(regra)" (click)="toggle(regra)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        @if (data.multiple) {
                            <mat-checkbox [checked]="isSelecionada(regra)" (click)="$event.stopPropagation()" (change)="toggle(regra)"></mat-checkbox>
                        }
                        <span class="text-bold">{{ regra.nome }}</span>
                    </div>
                </div>
                <div class="card-body-mobile p-3">
                    <p class="mb-1"><strong>CST IBS/CBS:</strong> <span class="status-badge badge-azul ms-1">{{ regra.cst }}</span></p>
                    <p class="mb-1"><strong>Cód. Classificação Trib.:</strong> <span class="status-badge badge-roxo ms-1">{{ regra.cclassTrib }}</span></p>
                    @if (regra.modelosDocumento && regra.modelosDocumento.length > 0) {
                        <p class="mb-0 d-flex flex-wrap gap-1 align-items-center">
                            <strong class="me-1">Modelos:</strong>
                            @for (modelo of regra.modelosDocumento; track $index) {
                                <span class="status-badge badge-cinza">{{ nomeModeloPorCodigo[modelo] ?? modelo }}</span>
                            }
                        </p>
                    }
                </div>
            </div>
        }
    </div>

    @if (regras.length < totalRegistros) {
        <div class="text-center mt-3">
            <button mat-button class="btn-ver-mais btn-spinner" [class.btn-loading]="isLoading" [attr.aria-label]="isLoading ? 'Carregando mais registros' : 'Ver mais'" type="button" [disabled]="isLoading" (click)="verMais()">
                <mat-icon class="material-symbols-outlined">expand_more</mat-icon>
                Ver Mais
                @if (isLoading) { <mat-spinner diameter="20"></mat-spinner> }
            </button>
        </div>
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button class="btn-secondary" type="button" (click)="abrirCadastro()">
        <mat-icon class="material-symbols-outlined">add</mat-icon>
        Cadastrar nova regra
    </button>
    <div class="ms-auto d-flex gap-2">
        <button mat-stroked-button class="btn-secondary" type="button" (click)="cancelar()">Cancelar</button>
        <button mat-flat-button class="btn-primary" type="button" [disabled]="selecionadas.length === 0" (click)="confirmar()">
            Confirmar seleção
        </button>
    </div>
</mat-dialog-actions>
